import { ASCEND, ASSETS } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function Ascend() {
  return (
    <section id="method" data-testid="ascend" className="relative py-24 md:py-40 bg-muted">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16 md:mb-24">
          <div className="lg:col-span-8">
            <Reveal>
              <Overline>The Method</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif text-5xl md:text-7xl font-light leading-[0.95] tracking-tight">
                The <span className="italic text-primary">ASCEND</span> Framework
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4">
            <Reveal delay={0.1}>
              <p className="text-lg leading-relaxed text-muted-foreground">
                An evidence-informed framework that reflects both behavioral
                science and leadership development. Six movements, one intention:
                design environments where everyone can flourish.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16">
          {ASCEND.map((c, i) => (
            <Reveal key={c.letter} delay={0.04 * (i % 2)}>
              <div className="relative border-t border-border py-10 md:py-12 group">
                <span className="pointer-events-none absolute right-0 -top-6 font-serif text-[9rem] md:text-[12rem] leading-none text-primary/[0.07] select-none">
                  {i + 1}
                </span>
                <div className="relative flex items-baseline gap-5">
                  <span className="font-serif text-5xl md:text-6xl font-light text-primary">
                    {c.letter}
                  </span>
                  <h3 className="font-serif text-3xl md:text-4xl font-light">
                    {c.title}
                  </h3>
                </div>
                <p className="relative mt-5 max-w-md text-base md:text-lg leading-relaxed text-muted-foreground">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-16 max-w-2xl text-sm italic text-muted-foreground">
            “Demonstrate” is chosen intentionally instead of “Deliver.” It
            reinforces a simple belief: if it matters, we should be able to measure
            it.
          </p>
        </Reveal>
      </div>

      <img
        src={ASSETS.clayTexture}
        alt=""
        aria-hidden
        className="pointer-events-none absolute -left-24 bottom-10 h-56 w-56 rounded-full object-cover opacity-20 blur-sm"
      />
    </section>
  );
}
